<template lang='pug'>
  .dropdown-container
    .dropdown-accordion.accordion(aria-multiselectable='true' role='tablist')
      .dropdown-header.collapsed(role='tab'
                                 data-toggle='collapse'
                                 data-target='#dropdown-nav'
                                 data-parent='.dropdown-accordion')
        .item.title(v-text='accountTitle')
        i.collapse-arrow
      #dropdown-nav.dropdown-content.collapse(role='tabpanel')
        template(v-for='link in accountLinks')
          router-link.item(v-if='link.routerLinked' :to='{ path: link.path }' v-text='link.label')
          a.item(v-else @click='trackBeautyProfileClick(link.path)' :href='link.path' v-text='link.label')
        .item.title(v-text='beautyPassTitle')
        template(v-for='link in beautyPassLinks')
          router-link.item(v-if='link.routerLinked' :to='{ path: link.path }' v-text='link.label')
          a.item(v-else :href='link.path' v-text='link.label')
</template>

<script>
import { pushDataLayerEvent } from '@/modules/services/gtm'

export default {
  props: [
    'accountTitle',
    'accountLinks',
    'beautyPassTitle',
    'beautyPassLinks'
  ],

  methods: {
    trackBeautyProfileClick (path) {
      if (path === '/account/beauty-profile') pushDataLayerEvent('beautyprofile_click_entry')
    }
  }
}
</script>

<style lang='scss' scoped>
  .dropdown-container {
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: left;
  }

  .dropdown-accordion {
    > .dropdown-header {
      align-items: center;
      border: 1px solid #cccccc;
      display: flex;
      padding: 10px 15px;
      width: 100%;
    }
  }

  .dropdown-header {
    > .item {
      @include font-weight-medium;
      text-transform: uppercase;
    }

    > .collapse-arrow {
      margin-right: 10px;
    }
  }

  .dropdown-content {
    > .item {
      display: block;
      border-left: 1px solid #cccccc;
      border-right: 1px solid #cccccc;
      border-bottom: 1px solid #cccccc;
      padding: 10px 15px;
    }

    > .title {
      @include font-weight-medium;
      text-transform: uppercase;
    }
  }
</style>
